import { get as _get } from 'lodash-es';
import type { Country } from '@shared/country';
import { Feature, isFeatureEnabled } from '@shared/features';

const careLineLive = window.CareLineLive;

const config = {
    ...(careLineLive?.config ?? {}),
};

export const country: Country = careLineLive?.country;

export default config;

export enum Branding {
    CareLineLive = 'carelinelive',
    Evaran = 'evaran',
}

export const branding: Branding = get('branding') === Branding.Evaran ? Branding.Evaran : Branding.CareLineLive;

export function isEvaranBranding(): boolean {
    return branding === Branding.Evaran;
}

export const debug = Boolean(config.debug || false);

export const cm2000Enabled = get('integrations.cm2000.enabled', false);

// Whether the integration is deployed for this environment at all (the deploy-time
// Feature flag alone) — gates route/nav reachability. Not the same as whether it will
// actually do anything; see totalMobileFullyEnabled for that.
export const totalMobileEnabled = isFeatureEnabled(Feature.TotalMobile);

// Whether the integration is deployed AND the runtime master setting has been turned
// on (TotalMobile::isEnabled() on the backend) — gates whether the TotalMobile pages
// render their real content or a "not enabled" placeholder.
export const totalMobileFullyEnabled = get('integrations.totalmobile.enabled', false);
export const hasteeEnabled = get('integrations.hastee.enabled', false);
export const abacusRedbridgeEnabled = get('integrations.abacus_redbridge.enabled', false);
export const tempaidEnabled: boolean = get('integrations.tempaid.enabled', false);
export const dynamicsGreatPlainsEnabled = get('integrations.dynamics_great_plains.enabled', false);
export const bhccEnabled = get('integrations.bhcc.enabled', false);
export const leicesterCityCouncilEnabled = get('integrations.leicester_city_council.enabled', false);
export const contrOccEnabled = get('integrations.controcc.enabled', false);
export const distanceUnits = config?.mileage?.units ?? 'miles';
export const distanceUnitSingular = distanceUnits === 'kilometres' ? 'kilometre' : 'mile';

export function get(path: string, defaultValue?: any): any {
    return _get(config, path, defaultValue);
}

export const company = get('company');

export const companyLatLng = (() => {
    if (company?.lat && company?.lng) {
        return { lat: company.lat, lng: company.lng };
    }
})();

export const companyName: string = careLineLive?.config?.company?.name;

export function isEnvironmentCountry(input: string | string[] | Country | Country[]): boolean {
    if (Array.isArray(input)) {
        return input.includes(country);
    }

    return input === country;
}

export const lookerHost: string = get('looker.host');
export const supportHelpUrl: string = get('support.helpUrl');
